export default [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "rightsRoot",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "addCategories",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];
